import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'firstLetterUpperCase' })

export class FirstLetterUpperCase implements PipeTransform {
	transform(value: any): any {

		if (!value) {
			return value;
		}

		const splitStr = value.toLowerCase().split(' ');

		for (let i = 0; i < splitStr.length; i++) {
			splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
			value = splitStr.join(' ');
		}

		return value;
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/pipe/firstletteruppercase.pipe.ts